import React from "react";

// eslint-disable-next-line import/prefer-default-export
export const Cleanser = (): React.ReactNode => (
  <svg
    viewBox="0 0 24 24"
    width="20px"
    height="20px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Pump head */}
    <rect x="10" y="2" width="4" height="2" rx="1" fill="currentColor" />
    <rect x="13" y="3" width="4" height="1.5" rx="0.75" fill="currentColor" />

    {/* Bottle body */}
    <rect x="7" y="5" width="10" height="16" rx="3" fill="currentColor" />

    {/* Label */}
    <rect x="9" y="9" width="6" height="5" rx="1.5" fill="white" />

    {/* Foam / bubbles */}
    <circle cx="11" cy="11" r="0.8" fill="currentColor" />
    <circle cx="13" cy="12.5" r="0.6" fill="currentColor" />
    <circle cx="12.5" cy="10" r="0.5" fill="currentColor" />
  </svg>
);
